module.exports = __webpack_public_path__ + "img/Hardware.2062b6df.jpg";